// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format25 } from '../../constants';

/** Kiribati */
const KI: PhoneNumberData = [686, 'KI', 8, format25];

export default KI;
